import { Icon, IconProps } from './Icon';

/** Same artwork as {@link LocationIcon}, for Google Places `.pac-icon` (non-React DOM). */
export const LOCATION_ICON_PAC_INLINE =
  '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" data-nc-loc="1" aria-hidden="true">' +
  '<path fill-rule="evenodd" clip-rule="evenodd" d="M4.27246 8.37083V8.2275C4.27246 5.06417 6.83663 2.5 9.99996 2.5V2.5C13.1633 2.5 15.7275 5.06417 15.7275 8.2275V8.37083C15.7275 11.255 12.0758 15.5967 10.6041 17.23C10.28 17.59 9.71996 17.59 9.39579 17.23C7.92413 15.5967 4.27246 11.255 4.27246 8.37083Z" stroke="#5E6A81" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
  '<path d="M8.33325 8.29516C8.33325 9.21599 9.07909 9.96182 9.99992 9.96182V9.96182C10.9208 9.96182 11.6666 9.21599 11.6666 8.29516V8.26432C11.6666 7.34349 10.9208 6.59766 9.99992 6.59766V6.59766C9.07909 6.59766 8.33325 7.34349 8.33325 8.26432" stroke="#5E6A81" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>' +
  '</svg>';

export const LocationIcon = ({ ...props }: IconProps) => (
  <Icon
    {...props}
    viewBox="0 0 20 20"
  >
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.27246 8.37083V8.2275C4.27246 5.06417 6.83663 2.5 9.99996 2.5V2.5C13.1633 2.5 15.7275 5.06417 15.7275 8.2275V8.37083C15.7275 11.255 12.0758 15.5967 10.6041 17.23C10.28 17.59 9.71996 17.59 9.39579 17.23C7.92413 15.5967 4.27246 11.255 4.27246 8.37083Z"
        stroke="#5E6A81"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33325 8.29516C8.33325 9.21599 9.07909 9.96182 9.99992 9.96182V9.96182C10.9208 9.96182 11.6666 9.21599 11.6666 8.29516V8.26432C11.6666 7.34349 10.9208 6.59766 9.99992 6.59766V6.59766C9.07909 6.59766 8.33325 7.34349 8.33325 8.26432"
        stroke="#5E6A81"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Icon>
);
